import { Link } from 'react-router-dom';

import ImgSlot from '@/ui/ImgSlot';
import type { Resident } from '@/types';

import styles from './ArtCardFrequency.module.css';

interface ArtCardFrequencyProps {
  artist: Resident;
  index: number;
}

export default function ArtCardFrequency({ artist, index }: ArtCardFrequencyProps) {
  const num = '/' + String(index + 1).padStart(3, '0');
  const href = `/artists/${artist.slug}`;

  return (
    <Link to={href} className={styles.cell} aria-label={artist.name}>
      <div className={styles.img}>
        <ImgSlot
          src={artist.portraitUrl}
          alt={artist.name}
          label={`${artist.name} · PORTRAIT`}
          mono
        />
      </div>
      <div className={styles.body}>
        <div className={styles.metaTop}>
          <span>{num}</span>
          <span>
            {artist.role === 'GUEST RESIDENT' ? 'GUEST' : 'RES'} · {artist.since}
          </span>
        </div>
        <div>
          <span className={styles.role}>{artist.tag}</span>
          <h3 className={styles.name}>{artist.name}</h3>
        </div>
        <div className={styles.genres}>
          {artist.genres.slice(0, 3).map((g) => (
            <span key={g}>{g}</span>
          ))}
        </div>
        <div className={styles.foot}>
          <div className={styles.wave}>
            {Array.from({ length: 8 }, (_, k) => (
              <i key={k} />
            ))}
          </div>
          <span className={styles.enter}>/ ENTER →</span>
        </div>
      </div>
    </Link>
  );
}
